import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import MediaStatistics from './MediaStatistics';
import TransmitStatistics from './TransmitStatistics';
import AnalysisDayStatistics from './AnalysisDayStatistics';
import AnalysisMcStatistics from './AnalysisMcStatistics';
import MediaHistory from './MediaHistory';

const AdExStatistics = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="AdExStatistics"
        tabMenuList={tabList()}
        tabs={{
          '/report/adex/day': {
            tabComponent: (
              <>
                <Statistics />
              </>
            ),
          },
          '/report/adex/media': {
            tabComponent: (
              <>
                <MediaStatistics />
              </>
            ),
          },
          '/report/adex/transmit': {
            tabComponent: (
              <>
                <TransmitStatistics />
              </>
            ),
          },
          '/report/adex/analysisday': {
            tabComponent: (
              <>
                <AnalysisDayStatistics />
              </>
            ),
          },
          '/report/adex/analysismc': {
            tabComponent: (
              <>
                <AnalysisMcStatistics />
              </>
            ),
          },
          '/report/adex/mediaHistory': {
            tabComponent: (
              <>
                <MediaHistory />
              </>
            ),
            isPop: 1,
          },
        }}
      ></MbTabs>
    </MainTemplate>
  );
};

export default AdExStatistics;
